
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/articles/[articleUrlName]",
      function () {
        return require("private-next-pages/press/articles/[articleUrlName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press/articles/[articleUrlName]"])
      });
    }
  